import React, { useState } from 'react';
import BackButton from '../components/BackButton';
import CategoriesList from '../components/CategoriesList';
import Filters from '../components/Filters';
import QuestionCard from '../components/QuestionCard';
import Tag from '../components/Tag';
import { useParams } from 'react-router-dom';
import { useQuestionsListQuery } from '../api/mutations/questions.mutation';
import Loader from '../components/Loader';
import { useSelector } from "react-redux";

const groupByDate = (data) => {
    return data?.reduce((acc, item) => {
        const dateObj = new Date(item.created_at);
        const day = dateObj.getDate().toString().padStart(2, '0');
        const month = dateObj.toLocaleString('default', { month: 'short' });
        const year = dateObj.getFullYear();

        const formattedDate = `${day} ${month} ${year}`;

        if (!acc[formattedDate]) acc[formattedDate] = [];
        acc[formattedDate].push(item);

        return acc;
    }, {});
};

const Categories = () => {
    const [filter, setFilter] = useState('all');
    const { slug } = useParams();
    const { isLoading, data } = useQuestionsListQuery(slug, filter);
    const grouped = groupByDate(data);
    const categories = useSelector((state) => state.category.data);

    const category = categories?.find((cat) => cat.id === slug);
    const categoryTitle = category?.title;

    const handleFilter = (name) => {
        setFilter(name);
    }
    
    if (isLoading) return <Loader />;

    return (
        <div className='categories'>
            <CategoriesList />
            <div className="container">
                <div className="categories-content">
                    <BackButton href="/" className="mb-32" />
                    <div className="categories-head flex flex-align-center flex-between mb-40">
                        <div>
                            <h2 className='mb-8'>• {categoryTitle}</h2>
                            <p className='text-min text-color-grey'>💡 Explore the list of captured Q&As. When you're ready, choose a question to instantly generate a tailored quiz for focused practice in this topic area.</p>
                        </div>
                        <div className='filters'>
                            <ul className='flex flex-align-center'>
                                <li>
                                    <button className={`${filter === 'all' ? 'active' : ''}`} onClick={() => handleFilter('all')}>All</button>
                                </li>
                                <li>
                                    <button className={`${filter === 'today' ? 'active' : ''}`} onClick={() => handleFilter('today')}>Today</button>
                                </li>
                                <li>
                                    <button className={`${filter === 'this_week' ? 'active' : ''}`} onClick={() => handleFilter('this_week')}>This Week</button>
                                </li>
                                <li>
                                    <button className={`${filter === 'last_week' ? 'active' : ''}`} onClick={() => handleFilter('last_week')}>Last Week</button>
                                </li>
                                <li>
                                    <button className={`${filter === 'this_month' ? 'active' : ''}`} onClick={() => handleFilter('this_month')}>This Month</button>
                                </li>
                            </ul>
                        </div>
                    </div>
                    {Object.keys(grouped).length === 0 ? (
                        <div className="no-data-found">
                            <h3>No data found</h3>
                        </div>
                        ) : (
                        Object.entries(grouped).map(([date, items]) => (
                            <div className="category-questions-box" key={date}>
                                <div className="questions-head flex flex-align-center">
                                    <div className="date mr-16">{date}</div>
                                    <Tag text={`${items.length} Captured Q&A`} />
                                </div>
                                {items.map((item) => (
                                    <QuestionCard
                                        key={item.id}
                                        id={item.id}
                                        question={item.question_text}
                                        answer={item.ai_answer || '—'}
                                        image={item.image_url}
                                        categoryTitle={categoryTitle}
                                    />
                                ))}
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
}

export default Categories;